import marketingOptinSubscribed from '@/resources/images/marketing-optin-subscribed-button.svg';
import marketingOptinUnsubscribed from '@/resources/images/marketing-optin-unsubscribed-button.svg';


const getIcon = (button) => {
  const iconMap = {
    website: 'open-line',
    URL: 'open-line',
    QUICK_REPLY: 'undo-solid',
    phone_number: 'call-line',
    calendar: 'calendar-line',
    location: 'pin-line',
    share: 'pin-line',
    postback: 'undo-solid',
    webview: 'open-line',
    app_webview: 'open-line',
    opt_in: marketingOptinSubscribed,
    opt_out: marketingOptinUnsubscribed,
  };
  if(button.payload == 'compliance_opt_in') {
    return iconMap['opt_in'];
  } else if(button.payload == 'compliance_opt_out') {
    return iconMap['opt_out'];
  }
  return iconMap[button.type] || '';
}

export { getIcon }
